import React, { useState } from "react";
import ReactECharts from "echarts-for-react";
import { Modal } from "../../../Components/Modals/SlaTable";
import { TbHandClick } from "react-icons/tb";

export function ProgressBar({ data }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const openModal = (params) => {
    const reversedIndex = data.length - 1 - params.seriesIndex;
    const actualValue = data[reversedIndex].SR_NUM_COUNT;
    if (actualValue === 0) return;

    setModalData({ ...params, seriesIndex: reversedIndex, actualValue });
    setModalData(params);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  const onEvents = {
    click: openModal,
  };

  const options = {
    title: {
      text: "SLA Breach Alert (As per expected closure date)",
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: (params) => {
        let tooltipText =
          '<div style="font-weight: bold;">Total SLA Breach:</div>';
        params.forEach((param, index) => {
          const reversedIndex = data.length - 1 - index;
          tooltipText += `<div style="color: ${param.color};"><span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background-color: ${param.color}; margin-right: 5px;"></span>${param.seriesName}: ${data[reversedIndex].SR_NUM_COUNT}</div>`;
        });
        return tooltipText;
      },
    },
    gend: {
      show: false,
    },
    grid: {
      top: "100%",
      left: "3%",
      right: "4%",
      bottom: "2%",
      containLabel: true,
    },
    xAxis: {
      show: false,
      type: "value",
      max: 3,
    },
    yAxis: {
      show: false,
      type: "category",
      axisLine: {
        show: false,
      },
    },
    series: [
      {
        name: "0-3 Days",
        type: "bar",
        stack: "total",
        label: {
          show: true,
          position: "inside",
          formatter: () => data[2].SR_NUM_COUNT,
        },
        emphasis: {
          focus: "series",
        },
        data: [1],
        itemStyle: {
          color: "green",
          borderRadius: [10, 0, 0, 10],
        },
        barWidth: "100%",
      },

      {
        name: "3-5 Days",
        type: "bar",
        stack: "total",
        label: {
          show: true,
          position: "inside",
          formatter: () => data[1].SR_NUM_COUNT,
        },
        emphasis: {
          focus: "series",
        },
        data: [1],
        itemStyle: {
          color: "#FFAD01",
          borderRadius: [0, 0, 0, 0],
        },
        barWidth: "100%",
      },

      {
        name: "More than 5 Days",
        type: "bar",
        stack: "total",
        label: {
          show: true,
          position: "inside",
          formatter: () => data[0].SR_NUM_COUNT,
        },
        emphasis: {
          focus: "series",
        },
        data: [1],
        itemStyle: {
          color: "red",
          borderRadius: [0, 10, 10, 0],
        },
        barWidth: "100%",
      },
    ],
  };

  return (
    <>
      <div>
        <ReactECharts
          option={options}
          onEvents={onEvents}
          style={{ height: "50px", width: "100%" }}
        />
        {isModalOpen && <Modal closeModal={closeModal} Modaldata={modalData} />}
        <p className="text-xs mt-1 flex items-center">
          <TbHandClick className="mr-1" /> to View Sla Breach Alert Details
        </p>
      </div>
    </>
  );
}
